import React from 'react';
import { phases } from '../../data/architecture';
export function PageInventory() {
  return <section aria-labelledby="inventory-h" className="bg-paper" data-id="element-255" data-mp="oijtlw95y928">
      <div className="mx-auto max-w-shell px-6 py-24 lg:px-10 lg:py-28" data-id="element-256" data-mp="ojuzq2q2zswi">
        <p className="label text-olive" data-id="element-257" data-mp="aq3ydhmi7fbv">Step three · The full build list</p>
        <h2 id="inventory-h" className="mt-6 max-w-3xl font-display text-[40px] font-300 leading-[1.03] text-ink sm:text-[52px]" data-id="element-258" data-mp="er5qzflx0t4v">
          Exactly what to build, in the order to build it
        </h2>
        <p className="mt-7 max-w-prose text-[16px] leading-[1.85] text-muted" data-id="element-259" data-mp="5su49oo66fhp">
          Structure first, then the twenty pages that will earn the most, then
          breadth, then money. Resist building new content until phase one is
          done — you already have traffic that isn’t going anywhere.
        </p>

        <div className="mt-16 space-y-16" data-id="element-260" data-mp="1m3y2r1bykybr">
          {phases.map((phase, i) => <article key={phase.phase} className="grid gap-10 border-t border-line pt-12 lg:grid-cols-[300px_1fr] lg:gap-20" data-id="element-261" data-mp="1q6kuz3cjkl9h" data-mpi={i}>
              <div data-id="element-262" data-mp="1539ujcpvl1nk">
                <p className="font-display text-[42px] font-300 leading-none text-ink/30" data-id="element-263" data-mp="1541hy09bjt2r">
                  {String(i + 1).padStart(2, '0')}
                </p>
                <h3 className="mt-5 font-display text-[32px] font-300 leading-tight text-ink" data-id="element-264" data-mp="1eturywttc04w">
                  {phase.phase}
                </h3>
                <p className="label mt-3 text-olive" data-id="element-265" data-mp="r6mp0ljux361">{phase.window}</p>
                <p className="mt-6 text-[14.5px] leading-[1.85] text-muted" data-id="element-266" data-mp="m6qudcx1uo35">
                  {phase.goal}
                </p>
              </div>

              <ul className="border-t border-line" data-id="element-267" data-mp="w3muau8vu1w3">
                {phase.pages.map(page => <li key={page.label} className="flex flex-wrap items-baseline justify-between gap-x-8 gap-y-1 border-b border-line py-5" data-id="element-268" data-mp="2chv3zo8k0gqb">
                    <span className="max-w-lg" data-id="element-269" data-mp="2em06xnpudl23">
                      <span className="block font-display text-[23px] font-300 leading-snug text-ink" data-id="element-270" data-mp="2el6ymib8inhu">
                        {page.label}
                      </span>
                      <span className="mt-1 block text-[13px] text-muted" data-id="element-271" data-mp="2ojmroqtto6tz">
                        {page.note}
                      </span>
                    </span>
                    <span className="label shrink-0 text-muted/80" data-id="element-272" data-mp="2tgwoirjjjkru">
                      {page.count}
                    </span>
                  </li>)}
              </ul>
            </article>)}
        </div>
      </div>
    </section>;
}